import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				wrapper: {
					font: {
						family: 'Arial', // Should be Heebo
					},
				},
			},
		},
		redirectButton: {
			children: {
				wrapper: {
					position: 'absolute',
					right: '10px',
				},
			},
		},
		summaryBlocks: {
			children: {
				wrapper: {
					box: {
						shadow: '0 6px 8px 1px rgb(0 0 0 / 12%), 0 2px 4px 0 rgb(0 0 0 / 8%)',
					},
					display: 'flex',
					flex: {
						direction: 'row',
					},
				},
			},
		},
	},
	theme: {
		base: {
			button: {
				color: '#0075be',
				background: {
					color: 'transparent',
				},
				font: {
					size: '13px',
					weight: '700',
				},
				padding: {
					_value: '15px 25px',
				},
				transition: {
					property: 'all',
					duration: '300ms',
					timingFunction: 'ease-out',
				},
				border: {
					_value: '2px solid #0075be',
					radius: '25px',
				},
				display: 'inline-flex',
				lineHeight: '13px',
				text: {
					align: 'center',
					decoration: 'none',
				},
				cursor: 'pointer',
				word: {
					break: 'break-word',
				},
				outline: {
					_value: 'none',
				},
			},
			card: {
				children: {
					title: {
						font: {
							size: '36px',
							weight: '300',
						},
						lineHeight: '43.2px',
					},
				},
			},
		},
		fact: {
			fact: {
				children: {
					wrapper: {
						display: 'flex',
						flex: {
							_value: '1',
							direction: 'column',
						},
						padding: {
							top: '40px',
							bottom: '30px',
						},
						text: {
							align: 'center',
						},
					},
					title: {
						font: {
							size: '16px',
							weight: '700',
						},
						lineHeight: '24px',
					},
					value: {
						font: {
							size: '32px',
							weight: '300',
						},
						lineHeight: '38.4px',
						color: '#2678c1',
					},
				},
			},
		},
	},
};